import { Suspense, createElement, ComponentType, lazy } from 'react';

const withLazy = <T extends {}>(
    load: () => Promise<{ default: ComponentType<T> }>
) => {
    const LazyComponent = lazy(load);

    return (props: T) => {
        return createElement(
            Suspense,
            { fallback: null },
            createElement(LazyComponent, props as any)
        );
    };
};

export default withLazy;
